<p class="sub-title">
  <span *ngFor="let item of breadCrumbList; let i = index; let last = last" (click)="openGsis(item.value)">
    {{ item.label }} {{ !last ? '/' : '' }}
  </span>
</p>
